module.exports = __webpack_public_path__ + "img/szjk_banner_wrods.699d47f1.png";